var $f55aa9fd85fa0ef8$exports = {};
function $f55aa9fd85fa0ef8$var$appendCanonicalLink() {
    const existing = document.querySelector('link[rel="canonical"]');
    if (existing) existing.remove();
    const link = document.createElement("link");
    link.rel = "canonical";
    const path = window.location.pathname.replace(/\/$/, "") || "/";
    link.href = window.location.origin + path;
    document.head.appendChild(link);
}
$f55aa9fd85fa0ef8$var$appendCanonicalLink();


//# sourceMappingURL=about-us.39f0ad0f.js.map
